import { CloudDoneOutlined } from "@mui/icons-material";
import {
  InfoText,
  AutoSaveStatusText,
  StatusSectionRoot,
} from "../../shared/practitionerForm.styles";
import * as C from "../IPHCPractitionerModal.constants";

const PractitionerStatusSection = ({ practitionerStatus, autoSaveStatus }) => {
  return (
    <StatusSectionRoot>
      <InfoText>
        {practitionerStatus ? (
          <>
            {C.STATUS_LABEL}{" "}
            <span style={{ color: "green" }}>{C.STATUS_APPROVED}</span>
          </>
        ) : (
          <>
            {C.STATUS_LABEL}{" "}
            <span style={{ color: "red" }}>{C.STATUS_PENDING}</span>
          </>
        )}
      </InfoText>
      {autoSaveStatus && (
        <AutoSaveStatusText $isSaving={autoSaveStatus === C.AUTO_SAVE_SAVING}>
          {autoSaveStatus !== C.AUTO_SAVE_SAVING && (
            <CloudDoneOutlined sx={{ fontSize: "16px" }} />
          )}
          {autoSaveStatus}
        </AutoSaveStatusText>
      )}
    </StatusSectionRoot>
  );
};

export default PractitionerStatusSection;
